/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Selection_LabelInputs */

const en_selection_label = /** @type {(inputs: Selection_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions for the selected items`)
};

const de_selection_label = /** @type {(inputs: Selection_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktionen für die ausgewählten Vorgänge`)
};

/**
* | output |
* | --- |
* | "Actions for the selected items" |
*
* @param {Selection_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const selection_label = /** @type {((inputs?: Selection_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selection_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_selection_label(inputs)
	return en_selection_label(inputs)
});